// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAllowContributionTaxConfigDto
 */
export interface IAllowContributionTaxConfigDto {
    /**
     * 
     * @type {boolean}
     * @memberof IAllowContributionTaxConfigDto
     */
    is_pre_tax?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IAllowContributionTaxConfigDto
     */
    pre_tax_memo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IAllowContributionTaxConfigDto
     */
    is_post_tax?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IAllowContributionTaxConfigDto
     */
    post_tax_memo?: string;
}

/**
 * Check if a given object implements the IAllowContributionTaxConfigDto interface.
 */
export function instanceOfIAllowContributionTaxConfigDto(value: object): value is IAllowContributionTaxConfigDto {
    return true;
}

export function IAllowContributionTaxConfigDtoFromJSON(json: any): IAllowContributionTaxConfigDto {
    return IAllowContributionTaxConfigDtoFromJSONTyped(json, false);
}

export function IAllowContributionTaxConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAllowContributionTaxConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_pre_tax': json['is_pre_tax'] == null ? undefined : json['is_pre_tax'],
        'pre_tax_memo': json['pre_tax_memo'] == null ? undefined : json['pre_tax_memo'],
        'is_post_tax': json['is_post_tax'] == null ? undefined : json['is_post_tax'],
        'post_tax_memo': json['post_tax_memo'] == null ? undefined : json['post_tax_memo'],
    };
}

export function IAllowContributionTaxConfigDtoToJSON(json: any): IAllowContributionTaxConfigDto {
    return IAllowContributionTaxConfigDtoToJSONTyped(json, false);
}

export function IAllowContributionTaxConfigDtoToJSONTyped(value?: IAllowContributionTaxConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_pre_tax': value['is_pre_tax'],
        'pre_tax_memo': value['pre_tax_memo'],
        'is_post_tax': value['is_post_tax'],
        'post_tax_memo': value['post_tax_memo'],
    };
}

